const VARIABLE_KEYS = ['competitorName', 'club', 'competition', 'position', 'discipline', 'category', 'belt', 'role']

// Serbian-language tokens shown/inserted in the editor going forward.
// Templates saved before this change still use the English keys above -
// resolveTemplate() accepts both so existing document types keep working
// without a migration.
const SR_TOKENS = {
  competitorName: 'imeTakmicara',
  club: 'klub',
  competition: 'nazivTurnira',
  position: 'pozicija',
  discipline: 'disciplina',
  category: 'kategorija',
  belt: 'pojas',
  role: 'uloga'
}
const SR_TOKEN_TO_KEY = Object.fromEntries(Object.entries(SR_TOKENS).map(([key, token]) => [token, key]))

// Maps a raw {{token}} (English or Serbian) found in a template string to
// its canonical VARIABLE_KEYS entry, or null if it isn't a known variable.
// Used both when resolving templates and when building manual-entry rows,
// so a manual row's keys always match what resolveVariable looks up -
// regardless of which token language the template was authored with.
function canonicalizeKey (token) {
  if (VARIABLE_KEYS.includes(token)) return token
  return SR_TOKEN_TO_KEY[token] || null
}

function placementLabel (placement) {
  if (placement === null || placement === undefined) return ''
  const labels = {
    1: '1. Mesto',
    2: '2. Mesto',
    3: '3. Mesto',
    4: '4. Mesto',
    5: '5. Mesto',
    6: '6. Mesto',
    7: '7. Mesto',
    8: '8. Mesto'
  }
  return labels[placement] || `${placement}. Mesto`
}

// The person's role in the print, e.g. "Trener" when printing coaches,
// "Takmičar" when printing competitors. For manual entries (people not in
// the system) this is left to the admin to type per row instead - see
// resolveVariable's manualValues check, which takes priority over this.
function roleLabel (target, entityType) {
  const labels = entityType === 'seminar'
    ? { competitors: 'Učesnik', clubs: 'Klub', coaches: 'Trener', officials: 'Zvaničnik', referees: 'Sudija' }
    : { competitors: 'Takmičar', clubs: 'Klub', coaches: 'Trener', officials: 'Zvaničnik', referees: 'Sudija' }
  return labels[target] || ''
}

function resolvePersonName (item) {
  // Same shape for every target: mapPeopleToCertificateEntities() already
  // normalizes coaches/officials/referees into item.competitor, so this
  // never needs to branch on `target`.
  if (item.competitor) {
    return `${item.competitor.firstName || ''} ${item.competitor.lastName || ''}`.trim()
  }
  if (item.registration?.teamMembers?.length) {
    return item.registration.teamMembers
      .map(m => `${m.firstName || ''} ${m.lastName || ''}`.trim())
      .filter(Boolean)
      .join(', ')
  }
  return ''
}

function resolveVariable (key, item, target, entityType, competitionName) {
  if (item.manualValues && Object.prototype.hasOwnProperty.call(item.manualValues, key)) {
    return item.manualValues[key] || ''
  }

  if (key === 'competitorName') {
    return resolvePersonName(item)
  }
  if (key === 'club') {
    const club = item.club
    return club ? (club.shortName || club.name || '') : ''
  }
  if (key === 'competition') {
    return competitionName || ''
  }
  if (key === 'role') {
    return roleLabel(target, entityType)
  }
  if (entityType === 'seminar') {
    // Discipline/category/belt/position have no seminar equivalent.
    return ''
  }
  if (key === 'position') {
    return item.diplomaPlacement != null ? placementLabel(item.diplomaPlacement) : ''
  }
  if (key === 'discipline') {
    return item.diplomaDiscipline || ''
  }
  if (key === 'category') {
    return item.diplomaCategory || ''
  }
  if (key === 'belt') {
    return item.competitor?.belt || ''
  }
  return ''
}

export function resolveTemplate (templateString, item, target, entityType, competitionName) {
  if (!templateString) return ''
  return templateString.replace(/\{\{(\w+)\}\}/g, (match, token) => {
    const key = canonicalizeKey(token)
    if (!key) return ''
    return resolveVariable(key, item, target, entityType, competitionName)
  })
}

export { VARIABLE_KEYS, SR_TOKENS, canonicalizeKey }
